<template>
    <template v-if="cart">
        <span class="h-[29px] w-[1px] bg-black"></span>
        <div class="group py-2">
            <div @click="navigateTo('/checkout')" ref="sideCartDetails" class="flex gap-3 cursor-pointer">
                <span class="relative flex items-center">
<!--                    <span v-if="cart?.items_count" class="rounded-full bg-sn-orange border border-sn-orange-dark w-5 h-5 absolute -top-2.5 -left-2.5 flex justify-center items-center text-white text-xs">-->
<!--                        {{ cart?.items_count }}-->
<!--                    </span>-->
                    <i class="fal fa-shopping-cart text-lg"></i>
                </span>
                <span>Total: <span v-text="formatPrice(cart?.subtotal_gross ?? 0)"></span></span>

            </div>
            <div class="absolute group-hover:block hidden top-10 right-0 w-[400px] shadow-xl border rounded-xl bg-white" ref="sideCart">
                <div class="flex justify-between p-4 gap-4 border-b">
                    <Button class="w-full" v-if="changedCartItems.length > 0" @click="updateCart" type="primary" size="medium">Update Cart</Button>
                    <Button @click="navigateTo('/checkout')" class="w-full" type="primary" size="medium">Checkout</Button>
                </div>
                <div class="max-h-[calc(100vh-100px)] overflow-y-scroll overflow-x-visible divide-y">
                    <div v-for="item in cartItems">
                        <SideCartItem :item="item" v-model="item.quantity" />
                    </div>
                </div>
            </div>
        </div>
    </template>
</template>


<script setup lang="ts">

import SideCartItem from "@/components/orderProcess/SideCartItem.vue";
import {formatPrice} from "@/composables/usePrice";
import {useCart} from "@/composables/useCart";
import Button from "@/components/core/Button.vue";
// import type {CartItemData} from "@/types/ecommerce";

const { cart, cartItems, changedCartItems, fetchCart, updateCart } = await useCart();
// const sideCartElement = useTemplateRef<HTMLElement>('sideCart');
const sideCartDetails = useTemplateRef<HTMLElement>('sideCartDetails');

// const itemQuantities = ref({});
// itemQuantities.value = cartItems.value.reduce((acc: Record<number,number>, item: CartItemData) => {
//     acc[item.id] = item.quantity;
//     return acc;
// }, {});

</script>